export function requireAiHqUiMutationApproval(): never {
  throw new Error("RUNTIME_BLOCKED: AI-HQ UI mutation approval context is not connected");
}
